import * as React from 'react';

import { PK } from 'common/types';
import { MEDIA_TYPES } from 'common/consts';
import { CollapsibleSection, MediaPicker, Title } from 'common/components';
import { useMinisMedia, useMinisMediaUpdate } from '../queries';

const fieldName = 'media_file_pks';

type Props = {
  pk?: PK;
};

const MiniMediaPicker = ({ pk: miniPk }: Props) => {
  const minisMedia = useMinisMedia(miniPk);
  const { mutate: save, isSuccess, isLoading, isError } = useMinisMediaUpdate();
  const saveStatus = { isSuccess, isLoading, isError };
  const defaultValues = minisMedia.data?.images;

  const handleSave = (mediaPks: PK[]) => {
    if (miniPk) {
      save({ pk: miniPk, [fieldName]: mediaPks });
    }
  };

  return (
    <>
      <CollapsibleSection
        title="Add media"
        saveStatus={saveStatus}
        disabled={!minisMedia.data}
      >
        <Title size="standard" marginBottom={1.5}>
          Linked image
        </Title>
        <MediaPicker
          onSave={handleSave}
          name={fieldName}
          mediaType={MEDIA_TYPES.IMAGE}
          defaultValues={defaultValues}
        />
      </CollapsibleSection>
    </>
  );
};

export default MiniMediaPicker;
